import { KeyboardEvent } from 'react';

import { CRAFT_ROOT_ID } from 'craft/constants';
import { shouldCraftIgnoreEvent } from 'craft/utils';
import { getDomNodeFromDocument } from 'craft/utils/viewport';

export const checkConditions = (...conditions: Array<(e?: KeyboardEvent) => boolean>) => (
  e: KeyboardEvent,
): boolean => {
  const rootDOM = getDomNodeFromDocument(CRAFT_ROOT_ID);

  // check if global conditions are met

  // TODO(mat) figure out how to make TS happy
  // Ignore any keyboard event that's outside of the ROOT DOM
  // @ts-ignore
  if (!e.composedPath().find((item) => item === rootDOM)) {
    return false;
  }

  // Events from these elements shouldnt be processed
  if (shouldCraftIgnoreEvent(e)) {
    return false;
  }

  return conditions.every((condition) => condition(e));
};
